import {createContext, SetStateAction, Dispatch} from 'react'

export const ActiveItemNavigationContext = createContext<{
  updateActiveNavItem: (s: string) => Dispatch<SetStateAction<string>> | void
}>({
  updateActiveNavItem: () => {},
})

export default ActiveItemNavigationContext.Provider
